// extracted by mini-css-extract-plugin
module.exports = {"BgCover":"App_BgCover__2dCdH","Wrapper":"App_Wrapper__1zdPa","ContentWrapper":"App_ContentWrapper__2jfSE"};